module.exports = __webpack_public_path__ + "static/media/address--location-icon.64713007.svg";